
/* injects from baggage-loader */

'use strict';

// node_modules
import "angular";
import "@uirouter/angularjs";
import "angular-resource";
import "oclazyload";
import "angular-animate";
import "angular-cookies";
import "angular-touch";
import "angular-sanitize";
import "angular-messages";
import "angular-aria";
import "jquery";
import "angular-resource";
import "angular-scroll";
import "angular-loading-bar";
import "angular-avatar";
import "angular-timeago";
import "angular-stripe";
import "./vendor/angular-payments";   // import "angular-payments";
import "ng-file-upload";
import "angular-drag-and-drop-lists";
import "angular-consent";


// Node module CSS
import "angular-loading-bar/build/loading-bar.css";

// Setup TextAngular
(() => {
  window.taTools = {};
  window.rangy = require('rangy/lib/rangy-core');
})();
// import 'textAngular/dist/textAngular.css';
require('rangy/lib/rangy-selectionsaverestore');
require('textangular/dist/textAngular-sanitize');
require('textAngular/dist/textAngularSetup');
require('textAngular/dist/textAngular');

// local scripts
//import "../assets/js/...";

// Setup Sentry
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';


// Make sure to call Sentry.init after importing AngularJS. 
// You can also pass {angular: AngularInstance} to the Integrations.Angular() constructor.
Sentry.init({
  dsn: 'https://5ccd84e0c6f64e1397d43f17ed4af858@sentry.io/1507294',
  integrations: [
    new Integrations.Angular(),
  ],
  // release: 1,
  // environment: 'prod',
  // beforeSend: (event, hint) => {
  //   console.log('Event!', event);
  //   return event;
  // }
});




// WEBPACK FOOTER //
// ./src/app/index.vendor.js